import Api from '../../api/global.service';
const colaEjecutar = () =>{Api.getAll('auth/console/queue');};
export default colaEjecutar;